// rem 适配
import "lib-flexible";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
import { setProjectUrl } from "jhm_api_ts";
// 设置项目根路径
const vueConfig = require("../jhm.config.js");
setProjectUrl(vueConfig.publicPath);

// 解决IOS下往返缓存问题
window.addEventListener("pageshow", (e) => {
  e.persisted && window.location.reload();
});

// import VConsole from "vconsole";
// // 调试按钮
// new VConsole({
//   onReady() {
//     ((document.querySelector("#__vconsole .vc-switch") ||
//       {}) as any).innerHTML = "测试专用";
//   },
// });

Vue.config.productionTip = false;

Vue.use(Vant);

Vue.config.ignoredElements = ["wx-open-launch-weapp"];

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
